import axios, { AxiosResponse } from 'axios'
import Api from './Api'
import { Vm } from '@/main';
import { Store } from './Store';

class RouteRepository {


    culture: () => string;


    constructor() {
        this.culture = () => (localStorage.getItem("culture") ? localStorage.getItem("culture") : "nl-BE") as string;
    }


    public async getRoutes(longitude: string | null, latitude: string | null): Promise<IRoute[]> {
        if (navigator.onLine) {
            try {
                var res = await Api.postData("Route/GetRoutes", {
                    longitude: longitude,
                    latitude: latitude
                });

                if (res.status == 200)
                    return res.data.routes;

            } catch {
                return [];
            }
        } else {
            return [];
        }

        return [] as IRoute[];
    }

    public async sendNotitions(firstName: string, email: string, code: string | null, contactMe: boolean, notitions: IRouteNotition[]): Promise<boolean> {
        if (navigator.onLine) {
            try {
                var res = await Api.postData("Route/PostNotitions", {
                    firstName: firstName,
                    email: email,
                    contactMe: contactMe,
                    code: code,
                    notitions: notitions
                });

                if (res.status == 200)
                    return true;

            } catch {
                return false;
            }
        } else {
            return false;
        }

        return false;
    }

    public async getRouteById(id: string): Promise<IRoute | undefined> {
        if (navigator.onLine) {
            try {
                var res = await Api.getData("Route/GetRouteById?id=" + id);

                if (res.status == 200) {
                    return res.data as IRoute;
                } else {
                    return undefined;
                }
            } catch {
                return undefined;
            }
        }

        return undefined;
    }

    public async getRouteIntroById(id: string): Promise<IRouteContent  | undefined> {
        if (navigator.onLine) {
            try {
                var res = await Api.getData("Route/GetIntroFromRouteId?id=" + id);

                if (res.status == 200) {
                    return res.data as IRouteContent;
                } else {
                    return undefined;
                }
            } catch {
                return undefined;
            }
        }

        return undefined;
    }

    public async commitRoute(code: string | null): Promise<boolean | undefined> {
        if (navigator.onLine) {
            try {
                var res = await Api.getData("Route/CommitRoute?code=" + code);

                if (res.status == 200) {
                    return res.data as boolean;
                } else {
                    return undefined;
                }
            } catch {
                return undefined;
            }
        }

        return undefined;
    }

    public async getRouteQuestions(id: string): Promise<IRouteQuestion[]> {
        if (navigator.onLine) {
            try {
                var res = await Api.getData("Route/GetRouteQuestions?id=" + id);

                if (res.status == 200) {
                    return res.data as IRouteQuestion[];
                } else {
                    return [];
                }
            } catch {
                return [];
            }
        }

        return [];
    }

    public async purchaseRoute(firstName: string, lastName: string, company: string, street: string, number: string, city: string, postalCode: string, vat: string, email: string, routeId: string): Promise<IRoutePurchaseOutput | undefined> {
        if (navigator.onLine) {
            try {
                var res = await Api.postData("Purchase/PurchaseRoute", {
                    firstName: firstName,
                    lastName: lastName,
                    company: company,
                    street: street,
                    number: number,
                    city: city,
                    postalCode: postalCode,
                    vat: vat,
                    email: email,
                    routeId: routeId
                });

                console.log(res);
                if (res.status == 200)
                    return res.data as IRoutePurchaseOutput;

            } catch (error) {
                return undefined;
            }
        } else {
            return undefined;
        }

        return undefined;
    }

    public async unlockRoute(code: string, routeId: string): Promise<string[]> {
        // if the user has a persistent cookie with the right code, all further checks are abandonned
        var cookieCode = this.getCookie("code");
        var ignoreDevice = false;
        console.log(cookieCode)
        console.log(code)
        if (cookieCode && cookieCode.toLowerCase() === code.toLowerCase())
            ignoreDevice = true;

        if (navigator.onLine) {
            var deviceId = localStorage.getItem("deviceId") ?? this.generateDeviceId()
            localStorage.setItem("deviceId", deviceId)
            try {
                var res = await Api.postData("Route/UnlockRoute", {
                    code: code,
                    routeId: routeId,
                    deviceId: deviceId,
                    ignoreDevice: ignoreDevice
                });

                if (res.status == 200) {
                   
                    this.setCookie("code", code, 365);
                    return [];
                }

            } catch (error) {
                var returnArr = [];
                console.log(error);
                var errRes = error.response;
                if (errRes && errRes.status !== 200) {
                    if ("" in errRes.data) {
                        returnArr = errRes.data[""];
                    }
                } else {
                    returnArr = ["not-online"];
                }
                return returnArr;
            }
        } else {
            return ["not-online"];
        }

        return ["not-online"];
    }

    private generateDeviceId(): string {
        var hashCode = (s: string) => s.split('').reduce((a, b) => { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0)

        return navigator.hardwareConcurrency + hashCode(navigator.platform) + hashCode(this.getMobileOperatingSystem()) + "";
    }

    private getMobileOperatingSystem(): string {
        var userAgent = navigator.userAgent || navigator.vendor;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android" + this.getAndroidVersion();
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS" + this.iOSversion;
        }

        return "unknown";
    }

    private getAndroidVersion(): string | undefined {
        var ua = (navigator.userAgent).toLowerCase();
        var match = ua.match(/android\s([0-9\.]*)/i);
        return match ? match[1] : undefined;
    }

    private iOSversion(): string {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
            var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);

            if (!v)
                return "";
            return parseInt(v[1], 10) + "." + parseInt(v[2], 10) + "." + parseInt(v[3] || "0", 10);
        }

        return "";
    }


    public async getRouteInfo(code: string, routeId: string): Promise<string> {
        if (navigator.onLine) {
            try {
                var res = await Api.postData("Route/RouteInfo", {
                    code: code,
                    routeId: routeId
                });

                if (res.status == 200)
                    return res.data.activeUntil as string;

            } catch (error) {
                return "error";
            }
        } else {
            return "error";
        }

        return "error";
    }

    private setCookie(name: string, value: string, days?: number | undefined) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    private getCookie(name: string): string | null {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    private eraseCookie(name: string) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}

export interface IRoute {
    routeId: string;
    name: string;
    price: number;
    commingSoon : boolean;
    active: boolean;
    distanceFromCurrentLocation: number;
    distance: number
    duration: number;
    iconPath: string;
    animationPath: string;
    routeContent: IRouteContent[];
    activeUntil: string | undefined;
}

export interface IRouteContent {
    id: string;
    routeId: string;
    type: string;
    routeOrder: number | undefined;
    sprint: ISprint[];
    longitude: number | undefined;
    latitude: number | undefined;
    icon: string | undefined;
    iconActive: string | undefined;
    name: string | undefined;
    askedInRange: boolean | undefined;
    read: boolean;
    routeGroup: number | undefined;
    customRoute: boolean;
    height: number | undefined;
    width: number | undefined;
    distanceNotification: number;
}

export interface ISprint {
    id: string;
    routeContentId: string;
    name: string;
    audioPath: string;
    displayOrder: number;
    sprintContent: ISprintContent[];
}

export interface ISprintContent {
    id: string;
    sprintId: string;
    type: string;
    content: string;
    displayOrder: number;
    name: string;
}


export interface IRouteNotition {
    routeContentId: string;
    items: IRouteNotitionContent[];
    displayOrder : number;
}

export interface IRouteNotitionContent {
    title: string;
    content: string;
    routeQuestionId: string;
    sprintId: string;
}

export interface IRoutePurchaseOutput {
    success: boolean;
    paymentUrl: string;
}

export interface IRouteQuestion {
    id: string;
    sprintId: string;
    displayOrder: number;
    question: string;
    timestamp: string;
}

export const RouteRepo = new RouteRepository();